export default {"src":"/_next/static/media/0x004626a008b1acdc4c74ab51644093b155e59a23.a517efca.svg","height":501,"width":501,"blurWidth":0,"blurHeight":0};